import React, { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import api from '../api';

function ResetPassword() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);

  if (!token) {
    return (
      <div className="form-page">
        <div className="form-container" style={{ maxWidth: '480px' }}>
          <div className="alert alert-danger">Invalid reset link. Please request a new one.</div>
          <a href="/forgot-password" className="btn btn-primary" style={{ marginTop: '1rem' }}>Request New Link</a>
        </div>
      </div>
    );
  }

  if (success) {
    return (
      <div className="form-page">
        <div className="form-container" style={{ maxWidth: '480px' }}>
          <div className="success-message">
            <h2>Password Reset!</h2>
            <p>Your password has been updated successfully.</p>
            <a href="/login" className="btn btn-primary" style={{ marginTop: '1rem' }}>Log In Now</a>
          </div>
        </div>
      </div>
    );
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (password !== confirm) { setError('Passwords do not match.'); return; }
    if (password.length < 8) { setError('Password must be at least 8 characters.'); return; }
    setLoading(true);
    try {
      await api.post('/api/auth/reset-password', { token, newPassword: password });
      setSuccess(true);
    } catch (err) {
      setError(err.response?.data?.error || 'Reset failed. The link may have expired.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="form-page">
      <div className="form-container" style={{ maxWidth: '480px' }}>
        <h1>Set New Password</h1>
        <p>Enter your new password below.</p>
        {error && <div className="alert alert-danger">{error}</div>}
        <form onSubmit={handleSubmit} className="registration-form">
          <div className="form-group">
            <label>New Password <span className="required">*</span></label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Minimum 8 characters"
              required
            />
          </div>
          <div className="form-group">
            <label>Confirm New Password <span className="required">*</span></label>
            <input
              type="password"
              value={confirm}
              onChange={(e) => setConfirm(e.target.value)}
              placeholder="Repeat your new password"
              required
            />
          </div>
          <button type="submit" disabled={loading} className="btn btn-primary">
            {loading ? 'Resetting...' : 'Reset Password'}
          </button>
        </form>
      </div>
    </div>
  );
}

export default ResetPassword;
